import * as React from 'react';
import { Component } from 'react';
import Header from './Header/Header';
import Content from './Content/Content';
import './Widget.scss';
import ErrorContainer from '../ErrorContainer/ErrorConainer';

interface IWidgetProps {
  /** Additional classes. */
  className?: string;
  /** A card can be indicated as interactive. */
  interactive?: boolean;
  /** To display error messages in cases hasError is true */
  hasError?: boolean;
}

/**
 * The Widget component is a flexible content container, often utilized to convey a logical arrangement of content and actions in a timeline/newsfeed layout.
 * @child ./Header/Header.tsx
 * @child ./Content/Content.tsx
 */

class Widget extends Component<IWidgetProps> {
  static defaultProps: Partial<IWidgetProps> = {
    interactive: true
  };

  static Header: typeof Header = Header;
  static Content: typeof Content = Content;
  render() {
    const { className, children } = this.props;
    const style = className ? `widget ${className}` : 'widget';
    return (
      <div className={style}>
        {this.props.hasError ? (
          React.Children.count(children) <= 1 ? (
            <ErrorContainer />
          ) : (
            React.Children.map(children, (child, i) => {
              if (i < 1) {
                return child;
              } else if (i === 1) {
                return <ErrorContainer />;
              } else {
                return;
              }
            })
          )
        ) : (
          children
        )}
      </div>
    );
  }
}
export default Widget;
